// test518
(518 && 0);
